module.exports = __webpack_public_path__ + "static/media/update_empty_state.6de15d56.svg";